/**
 * Hanko Frontend SDK Initialization
 *
 * Configures the Hanko frontend SDK for the Console React app.
 * Must be imported ONCE at app startup (in index.js).
 *
 * This sets up the Hanko client for:
 * - Flow API (login, registration, profile management)
 * - Session management (cookie-based JWTs)
 * - Event listeners (session created, user logged out)
 */

import { Hanko } from '@teamhanko/hanko-frontend-sdk';

const HANKO_API_URL = process.env.REACT_APP_HANKO_URL || 'http://localhost:8000';

// cookieDomain MUST be set so the session cookie is written with
// Domain=samsurveyor.com (parent scope) instead of host-scope. Without
// this, the SDK defaults to the current page's host (console.samsurveyor.com)
// and the cookie never rides to designer.samsurveyor.com / api.samsurveyor.com
// / explorer.samsurveyor.com — Designer/Explorer /me calls 401 even though
// the user is signed in to Console. The Hanko server's session.cookie.domain
// config does NOT control this; the SDK writes the cookie client-side.
//
// It is only correct on a samsurveyor.com page, though. A browser refuses to
// write a cookie for a domain the page is not on, and it refuses silently. So
// on localhost, and on the cloudsam-console-*.run.app hosts, this option meant
// no session cookie was written at all. Ask for it only where it can work.
const SESSION_COOKIE_DOMAIN = 'samsurveyor.com';

/** The cookie domain to use here, or undefined when this page is not on it. */
function cookieDomainForThisHost() {
    const host = (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
    if (host === SESSION_COOKIE_DOMAIN || host.endsWith(`.${SESSION_COOKIE_DOMAIN}`)) {
        return SESSION_COOKIE_DOMAIN;
    }
    return undefined;
}

const cookieDomain = cookieDomainForThisHost();
const hanko = cookieDomain ? new Hanko(HANKO_API_URL, { cookieDomain }) : new Hanko(HANKO_API_URL);

export { hanko, HANKO_API_URL };
export default hanko;
